import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  LogoLoader,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { Link, useNavigate } from "react-router-dom";
import { mapTableRows } from "../../../../utils/mapTableRows";
//
import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeesStart,
  setEmployeeProfileUiid,
} from "../../../../redux/slices/employee/employeeSlice";
import {
  getValueByKey,
  formatWords,
  dateFormator,
  getEmployeeId,
} from "../../../../utils";
import { useAdvPagination } from "../../../../hooks";
const AllEmployees = ({ tab = "Overview" }) => {
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({ field: "uiid", direction: 1 });
  const [searchValue, setSearchValue] = useState("");
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );
  const isLoading = loading;
  const paginationMemory = localStorage.getItem("all-employee-limit") || 25;
  const { page, limit, setPage, handleLimitChange } = useAdvPagination(
    paginationMemory,
    (newPage, newLimit) => {
      dispatch(getEmployeesStart({ page: newPage, limit: newLimit }));
    },
  );

  const tableData = employees?.data || []; // Add null check with default empty array

  const handleEdit = (row) => {
    alert(row.code);
  };
  // const handleSort = (field) => {
  //   setSortConfig((prevSort) => ({
  //     field,
  //     // Toggle between 1 (ascending) and -1 (descending)
  //     direction: prevSort.field === field ? -prevSort.direction : 1,
  //   }));
  // };

  const handleSort = (field, direction) => {
    setSortConfig({
      field,
      direction: direction === "asc" ? 1 : -1,
    });
  };
  const columns = [
    {
      key: "code",
      label: "Code",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">
              {getEmployeeId(row.uiid, row.employmentType)}
            </span>
          </Link>
        </div>
      ),

      sortfun: (direction = "asc") => handleSort("uiid", direction),
    },
    {
      key: "firstName",
      label: "First Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.firstName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-2">
            <Avatar
              alt={row.firstName}
              size="sm"
              outline
              src={row.profilePhotoUrl}
            />
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              className="truncate max-w-[200px]"
            >
              {row.firstName}
            </Link>
          </div>
        </SmartTooltip>
      ),

      sortfun: (direction = "asc") => handleSort("firstName", direction),
    },
    {
      key: "lastName",
      label: "Last Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.lastName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.lastName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: (direction = "asc") => handleSort("lastName", direction),
    },
    {
      key: "middleName",
      label: "Middle Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.middleName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.middleName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: (direction = "asc") => handleSort("middleName", direction),
    },
    {
      key: "employmentType",
      label: "Employment Type",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {formatWords(
              "",
              getValueByKey(row.employmentType, "EmploymentType"),
            )}
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("employmentType", direction),
    },
    {
      key: "status",
      label: "Employee Status",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <StatusTags
              tag={formatWords("", getValueByKey(row.status, "EmployeeStatus"))}
            />
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("status", direction),
    },
    {
      key: "email",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.primary}</span>
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("email.primary", direction),
    },
    {
      key: "alternateEmailId",
      label: "Alternate Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.secondary || "-"}</span>
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("email.secondary", direction),
    },
    {
      key: "category",
      label: "Category",
      sortfun: (direction = "asc") => handleSort("category", direction),
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {row?.category ? row?.category : "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "location",
      label: "Country",
      width: "text-nowrap",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {row.location.country}
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("location.country", direction),
    },
    {
      key: "cityState",
      label: "City/State",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => {
        const value = `${row?.location?.city || ""}, ${row?.location?.state || ""}`;

        return (
          <SmartTooltip
            description={value}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              <Link
                to="/employee/employee-profile"
                onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              >
                {value}
              </Link>
            </div>
          </SmartTooltip>
        );
      },
      sortfun: (direction = "asc") => handleSort("location.state", direction),
    },
    {
      key: "fullAddress",
      label: "Full Address",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
            description={row.location.address1}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
        <div className="flex items-center gap-1 line-clamp-1!">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {row.location.address1}
          </Link>
        </div>
        </SmartTooltip>
      ),
      sortfun: (direction = "asc") =>
        handleSort("location.address1", direction),
    },

    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[350px]!",
      sortfun: (direction = "asc") =>
        handleSort("location.address1", direction),
      render: (row) => (
        <SmartTooltip
            description={row.jobTitle}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
        <div className="flex items-center gap-1 line-clamp-1!">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {formatWords("", row.jobTitle)}
          </Link>
        </div>
        </SmartTooltip>
      ),
    },
    {
      key: "joinDate",
      label: "Date of Joining",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {dateFormator(row.joinDate, "month-day-year")}
          </Link>
        </div>
      ),
      sortfun: (direction = "asc") => handleSort("joinDate", direction),
    },
    {
      key: "",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit"
          size="xs"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getEmployeesStart({
        limit,
        page,
        filters: {
          ...(tab === "Employees"
            ? { employmentType: { type: "IN", value: [1, 4] } }
            : {}),
          // "isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: false },
          all: {
            type: "SEARCH",
            value: searchValue,
          },
          status: { type: "NONE", value: 1 },
        },
        ret: "uiid employmentType profilePhotoUrl firstName middleName lastName status email category location jobTitle joinDate",
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    const setLimitInLocalStorage = () => {
      localStorage.setItem("all-employee-limit", limit || 0);
    };
    setLimitInLocalStorage();
  }, [dispatch, page, limit, sortConfig, tab, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <TableAdv
        rows={mappedRows}
        columns={columns}
        fixedCol={3}
        showSlNo
        // need to add table id for every TableAdv for working filter and other features
        tableId={"Employee-AllEmployees-v3"}
        page={page}
        limit={limit}
        // selectList={[15, 25, 30]}
        serverPagination={true}
        totalCount={totalCount?.data}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        // showCheckbox
        serverSearchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search: true,
          filter: true,
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AllEmployees;
